import { getOrderStatusString } from 'src/utils/order';

export const NON_FILL_ACTIONS: ReadonlyArray<
	ReturnType<typeof getOrderStatusString>
> = [
	'Cancelled',
	'Expired',
	'Open',
	'Triggered',
	'Partially Filled (Cancelled)',
] as const;
